export default __webpack_public_path__ + "static/media/add.6d90fbe7.svg";